import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { verifySubscribeEmail, verifyUnsubscribeEmail } from 'Components/Public/Footer/SubscribeAxiosFuncs';

const DEFAULT_SUCCESS = {
    subscribe: 'Thank you for subscribing to the PSOPPC notifications!',
    unsubscribe: 'You have been unsubscribed from email notifications from PSOPPC.',
};
const FALLBACK_ERROR = 'Something went wrong. Please try again or contact support@psoppc.org.';

function EmailVerifyPage({ type }) {
    const { '*': token } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const verify = type === 'subscribe' ? verifySubscribeEmail : verifyUnsubscribeEmail;
        verify(token)
            .then(res => {
                const success = res?.data?.status === 1;
                navigate('/', {
                    replace: true,
                    state: {
                        emailVerifyResult: {
                            status: success ? 'success' : 'error',
                            message: success
                                ? (res.data.message ?? DEFAULT_SUCCESS[type])
                                : (res?.data?.globalErrorMessageList?.[0] ?? FALLBACK_ERROR),
                        }
                    }
                });
            })
            .catch(err => {
                navigate('/', {
                    replace: true,
                    state: {
                        emailVerifyResult: {
                            status: 'error',
                            message: err?.data?.globalErrorMessageList?.[0] ?? FALLBACK_ERROR,
                        }
                    }
                });
            });
    }, []);

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            Verifying...
        </div>
    );
}

export default EmailVerifyPage;
